export default __webpack_public_path__ + "static/media/portal-logo.3d2d2e0a.png";